import * as React from 'react'
import { Plus, type LucideIcon } from 'lucide-react'
import { cn } from '../lib/utils'

/**
 * AddTile — компактная плитка «добавить» (пунктирный контур + иконка «+»).
 * Для добавления элемента в сетку/список (градиент, фон, вариант).
 * Размер/пропорция — через className (aspect-square, h-20 и т.п.).
 * forwardRef — чтобы работать как PopoverTrigger asChild.
 */
export interface AddTileProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: LucideIcon
  label?: string
}

export const AddTile = React.forwardRef<HTMLButtonElement, AddTileProps>(
  ({ icon: Icon = Plus, label, className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'flex items-center justify-center gap-1.5 rounded-2xl border-2 border-dashed border-border text-muted-foreground hover:border-white hover:text-foreground hover:bg-foreground/5 transition-colors cursor-pointer disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <Icon className="w-5 h-5 shrink-0" />
      {label && <span className="text-xs font-medium">{label}</span>}
      {children}
    </button>
  ),
)
AddTile.displayName = 'AddTile'
